const style = (theme) => {
  const output = {
    cardBackgroundPrimary: {
      backgroundColor: theme.colors[3],
    },
    cardBackgroundSecondary: {
      backgroundColor: theme.colors[4],
    },
    card: {
      position: 'relative',
      width: '100%',
      paddingBottom: '130%',
      overflow: 'hidden',
      borderRadius: 16,
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      '& > div': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& svg': {
        width: 150,
        height: 150,
        fill: theme.colors[1],
      },
    },
    cardInfo: {
      marginTop: 25,
      textAlign: 'center',
      fontSize: 18,
      color: theme.colors[1],
      lineHeight: 1.2,
      '& p': {
        marginBottom: 0,
      },
    },
  }

  output[theme.mediaInverse.md] = {
    card: {
      '& svg': {
        width: 80,
        height: 80,
      },
    },
    cardInfo: {
      fontSize: 14,
    },
  }

  output[theme.mediaInverse.sm] = {
    card: {
      '& svg': {
        width: 150,
        height: 150,
      },
    },
    cardInfo: {
      fontSize: 18,
    },
  }

  return output
}
export default style
